import {observer, useAsObservableSource} from 'mobx-react-lite';
import styled from '@emotion/styled';
import React from 'react';
import Icon from '../../../Icon/Icon';

interface PropsType {
    label: string
}

export const StatusInfo = observer((propsIn: PropsType) => {
    const props = useAsObservableSource(propsIn);
    const {label} = props;

    return (<Wrapper>
        <StyledIcon name={'info'}/>
        <Label>{label}</Label>
    </Wrapper>);
});

const Wrapper = styled('div', { label: 'Wrapper' })`
    display: flex;
    align-items: center;
    flex: 1 0 100%;
    margin: 16px 0;
`;

const StyledIcon = styled(Icon, { label: 'StyledIcon' })`
    margin-right: 8px;
    font-size: 24px;
`;

const Label = styled('span', { label: 'Label' })`
    font-size: 14px;
    line-height: 1;
    user-select: none;
`;
